<template>
	<div class="text-xs-center mt-3">
		<label class="info--text body-1 title-detail">{{ title }}:</label>
		<p class="caption info--text description">{{ description }}</p>
	</div>
</template>

<script>
	export default {
		name: 'card-detail',
		props: {
			description: String,
			title: String,
		},
	};
</script>

<style lang="scss" scoped>
	.description {
		line-height: normal;
		margin: 10px auto;
		max-width: 210px;
	}

	.title-detail {
		font-family: map-get($fonts, bold);
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/card-detail.vue